import { NativeModules, Platform } from 'react-native';

// This value is compiled into the signed Mac executable. User defaults,
// receipts, server flags and the presence of an updater never select billing.
export function isMacAppStore() {
  return Platform?.OS === 'macos' && NativeModules?.MacMenuBridge?.distribution === 'appstore';
}

// Descriptive request context, never a permission grant. Read the signed
// native build rather than a preference, account flag or caller-supplied body.
export function workClientEnvironment() {
  if (Platform.OS !== 'macos') return undefined;
  const native = NativeModules?.MacMenuBridge;
  return { platform: 'macos', distribution: isMacAppStore() ? 'appstore' : 'direct',
    ...(native?.appVersion && { version: String(native.appVersion) }),
    ...(native?.appBuild && { build: String(native.appBuild) }) };
}

export function usesStoreBilling() {
  return ['ios', 'android'].includes(Platform.OS) || isMacAppStore();
}

export function usesHostedBilling() {
  return Platform.OS === 'web' || (Platform.OS === 'macos' && !isMacAppStore());
}

export function requiresAiSharingConsent() {
  // Mobile privacy popup temporarily disabled at the product owner's request.
  // Keep the dialog, saved receipts and guards ready to restore together:
  // return Platform.OS === 'ios' || isMacAppStore();
  return isMacAppStore();
}

// Defense in depth for stale modals/deep links. Cancellation, invoices,
// account access and Apple's transaction-validation endpoints remain usable.
export function assertPaymentRequestAllowed(url, method = 'GET') {
  if (!isMacAppStore()) return;
  const path = String(url).replace(/^https?:\/\/[^/]+/, '').split('?')[0];
  const hosted = /^\/json\/payments\/(checkout-authorization|whop\/checkout|extend-subscription)$/.test(path)
    || /^\/json\/(account|credits)\/(create-btcpay-invoice|quick-purchase|update-payment-method|whop-portal)$/.test(path)
    || /^\/json\/paddle\/subscription\/[^/]+\/update-payment-method$/.test(path)
    || (path.startsWith('/json/account/auto-topup') && !['GET', 'HEAD'].includes(method.toUpperCase()));
  if (hosted) throw new Error('Purchases in this edition use the App Store.');
}
